/* ============================================================
KENSONS CUSTOM – Mobile Footer Accordion
============================================================ */
document.addEventListener('DOMContentLoaded', () => {
  const mq = window.matchMedia('(max-width: 989px)'); // typischer mobile breakpoint

  const init = () => {
    const footer = document.querySelector('footer');
    if (!footer) return;

    // Kandidaten: Footer-Menü-Headlines (Theme-abhängig)
    const headings = footer.querySelectorAll('h2, h3, .footer__heading, .footer-block__heading');
    headings.forEach(h => {
      const block = h.closest('div, .footer-block, .footer__block') || h.parentElement;
      if (!block) return;

      // Nur wenn darunter wirklich Links/Content sitzt
      const content = block.querySelector('ul, .footer__content, .footer-block__content, nav');
      if (!content) return;

      // Doppelte Initialisierung verhindern
      if (block.dataset.kensonsAccordion === '1') return;
      block.dataset.kensonsAccordion = '1';

      // Klickbar machen
      h.style.cursor = 'pointer';
      h.setAttribute('aria-expanded', 'false');

      // Startzustand (mobil zu)
      const setClosed = () => {
        content.style.maxHeight = '0px';
        content.style.overflow = 'hidden';
        content.style.transition = 'max-height 250ms ease';
        block.classList.add('kensons-footer-collapsed');
        h.setAttribute('aria-expanded', 'false');
      };

      const setOpen = () => {
        content.style.maxHeight = content.scrollHeight + 'px';
        block.classList.remove('kensons-footer-collapsed');
        h.setAttribute('aria-expanded', 'true');
      };

      const toggle = () => {
        const collapsed = block.classList.contains('kensons-footer-collapsed');
        collapsed ? setOpen() : setClosed();
      };

      // Mobil initial schließen
      if (mq.matches) setClosed();
      else {
        // Desktop: offen
        content.style.maxHeight = 'none';
        content.style.overflow = 'visible';
        block.classList.remove('kensons-footer-collapsed');
        h.setAttribute('aria-expanded', 'true');
      }

      h.addEventListener('click', () => {
        if (!mq.matches) return; // nur mobil
        toggle();
      });
    });
  };

  init();
  window.addEventListener('resize', init);
});


/* ============================================================
KENSONS CUSTOM – Shopify Inbox Badge Color Override (Shadow DOM)
============================================================ */
document.addEventListener('DOMContentLoaded', () => {
  const BADGE_BG = '#c7a36a';   // <- hier ändern (z.B. #432818)
  const BADGE_TEXT = '#ffffff'; // Textfarbe im Badge

  const applyBadgeStyle = (shadowRoot) => {
    if (!shadowRoot) return;

    const badge = shadowRoot.querySelector('.chat-notification');
    if (!badge) return;

    // Inline style with !important so it wins against extension CSS
    badge.style.setProperty('background', BADGE_BG, 'important');
    badge.style.setProperty('background-color', BADGE_BG, 'important');
    badge.style.setProperty('color', BADGE_TEXT, 'important');
    badge.style.setProperty('border', '0', 'important');
    badge.style.setProperty('box-shadow', 'none', 'important');
  };

  const hookInboxWidget = () => {
    const el = document.querySelector('inbox-online-store-chat');
    if (!el) return false;

    const sr = el.shadowRoot;
    if (!sr) return false;

    // Apply immediately (if badge already exists)
    applyBadgeStyle(sr);

    // Badge is often injected dynamically -> observe changes inside shadow DOM
    const obs = new MutationObserver(() => applyBadgeStyle(sr));
    obs.observe(sr, { childList: true, subtree: true });

    return true;
  };

  // Try now + retry a few times (widget loads async)
  if (hookInboxWidget()) return;

  let tries = 0;
  const timer = setInterval(() => {
    tries += 1;
    if (hookInboxWidget() || tries >= 40) clearInterval(timer); // ~10s max
  }, 250);
});
